(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["center-carousel"] && !Shopify.designMode) return;
  try {
    
/* --- Slick Carousel Initialization --- */

if (typeof $.fn.slick === 'undefined') {
  var slickCSS = document.createElement('link');
  slickCSS.rel = 'stylesheet';
  slickCSS.href = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css';
  document.head.appendChild(slickCSS);

  var slickTheme = document.createElement('link');
  slickTheme.rel = 'stylesheet';
  slickTheme.href = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css';
  document.head.appendChild(slickTheme);

  var slickScript = document.createElement('script');
  slickScript.src = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
  document.head.appendChild(slickScript);
}

$(document).ready(function(){
  var $carousel = $('.carousel');

$carousel.slick({
  centerMode: true,
  infinite: true,
  slidesToShow: 5,
  focusOnSelect: true,
  arrows: false,
  variableWidth: false,

  responsive: [
    {
      breakpoint: 768, // mobile (<768px)
      settings: {
        slidesToShow: 3,
        centerMode: true,
      }
    }
  ]
});

  $('.carousel-next').click(function() {
    $carousel.slick('slickNext');
  });
  $('.carousel-prev').click(function() {
    $carousel.slick('slickPrev');
  });

  // Update content on slide change
  $carousel.on('afterChange', function(event, slick, currentSlide){
    var $current = $('.slick-center');

    $('.carousel-title').text($current.data('heading'));

    // Get pre-rendered HTML from hidden slide-desc
    var descHtml = $current.find('.slide-desc').html() || '';
    $('.carousel-description').html(descHtml);
  });
});

  } catch(e) { console.error(e); }
})();
})();
